import {
    BarLine,
    ButtonContainer,
    Container,
    InputWrap,
    TotalResultText,
} from '../users/style';
import {
    Counter,
    CsvDownloader,
    Loader,
    PdfDownloader,
    SelectComp,
} from '../../common/component';
import { Grid, Header } from '../dashboard/styles';
import { TableCompData } from '../../common/component/table';
import {
    AdvertTableHeader,
    cleanUpTradeAdvertDataForPdf,
} from '../../common/utils/dataUtils';
import { BsEye } from 'react-icons/bs';
import { ContainerComp } from '../../common/component/Ui/containerComp';
import { Col, FormControl } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import SearchIcon from '../../common/images/search_icon.svg';
import { ReactComponent as AdvertIcon } from '../../common/images/advert_icon.svg';
import {
    useGetAllAdvertQuery,
    useAdvertStatsQuery,
} from '../../store/advertApi';
import { IAdvert } from '../../store/advertApi/interface';

export const Advert = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [dropDownTerm, setDropDownTerm] = useState('');
    const [filteredTradeAdvert, setfilteredTradeAdvert] = useState<
        IAdvert[] | any
    >();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(100);
    const paginate = {
        perPage: rowsPerPage,
        currentPage: currentPage,
    };
    const {
        data: allAdvert,
        isLoading,
        isFetching,
    } = useGetAllAdvertQuery(paginate, {
        refetchOnMountOrArgChange: true,
    });
    const { data: advertStats } = useAdvertStatsQuery();

    useEffect(() => {
        setTotalRows(allAdvert?.pagination?.totalDocumentCount as number);
    }, [allAdvert?.pagination?.totalDocumentCount]);
    const handlePageChange = (page: any) => setCurrentPage(page);
    const handleRowsPerPageChange = (newRowsPerPage: any) => {
        if (!allAdvert?.data?.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchUsers again
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const Items = [
        {
            name: ' View Advert',
            icon: <BsEye size={15} />,
            link: '/dashboard/trade-advert/view',
            id: '_id',
        },
    ];

    // To implement search and dropdown input
    useEffect(() => {
        if (searchTerm === '' && dropDownTerm === '') {
            setfilteredTradeAdvert(allAdvert?.data);
        }
        if (dropDownTerm !== '') {
            let filteredItems = allAdvert?.data?.filter((item: IAdvert) => {
                return item?.currencyPair?.baseCurrency?.currencyType
                    .toLowerCase()
                    .includes(dropDownTerm.toLowerCase());
            });
            setfilteredTradeAdvert(filteredItems);
        }
        if (searchTerm !== '') {
            let searchItems = allAdvert?.data?.filter((item: IAdvert) => {
                return (
                    item?.user?.firstName
                        ?.toLowerCase()
                        .includes(searchTerm?.toLowerCase()) ||
                    item?.user?.lastName
                        ?.toLowerCase()
                        .includes(searchTerm?.toLowerCase())
                );
            });
            setfilteredTradeAdvert(searchItems);
        }
    }, [allAdvert, searchTerm, dropDownTerm]);

    //add the header like this and just send array of Data to CsvDownloader
    const headersCsv = [
        { label: 'First Name', key: 'user.firstName' },
        {
            label: 'Last Name',
            key: 'user.lastName',
        },
        {
            label: 'Category',
            key: 'currencyPair.baseCurrency.currencyType',
        },
        {
            label: 'Amount',
            key: 'price',
        },
        {
            label: 'Advert type',
            key: 'advertType',
        },
    ];

    //add the header like this and just send array of Data to pDFDownloader
    const headersPdf = [
        { header: 'First Name', dataKey: 'firstName' },
        {
            header: 'Last Name',
            dataKey: 'lastName',
        },
        {
            header: 'Category',
            dataKey: 'category',
        },
        {
            header: 'Amount',
            dataKey: 'amount',
        },
        {
            header: 'Advert type',
            dataKey: 'advertType',
        },
    ];

    return (
        <Container>
            {isLoading && <Loader />}
            <Header>Trade Adverts</Header>
            <Grid>
                <Counter
                    counter_title="Total Ads"
                    count={advertStats?.data?.totalAdverts || '0'}
                    iconFill="blue"
                    iconBG="blue"
                >
                    <AdvertIcon />
                </Counter>
                <Counter
                    counter_title="Active Ads"
                    count={advertStats?.data?.activeAdverts || '0'}
                    iconFill="green"
                    iconBG="green"
                >
                    <AdvertIcon />
                </Counter>
                <Counter
                    counter_title="Buy Ads"
                    count={advertStats?.data?.buyAdverts || '0'}
                >
                    <AdvertIcon />
                </Counter>
                <Counter
                    counter_title="Sell Ads"
                    count={advertStats?.data?.sellAdverts || '0'}
                    iconFill="red"
                    iconBG="red"
                >
                    <AdvertIcon />
                </Counter>
            </Grid>
            <div className="d-xl-flex align-items-center justify-content-between mt-5 mb-3">
                <Col
                    sm={12}
                    xl={9}
                    className="d-flex flex-column flex-sm-row align-items-center justify-content-between"
                >
                    <Col
                        xs={10}
                        sm={6}
                        className="d-flex align-items-center my-3"
                    >
                        <SelectComp
                            selectText="All advert"
                            arrayComp={['Fiat', 'Crypto']}
                            onChange={(e: any) =>
                                setDropDownTerm(e.target.value)
                            }
                        />
                        <TotalResultText>{`${
                            filteredTradeAdvert?.length || 0
                        } result`}</TotalResultText>
                    </Col>
                    <InputWrap>
                        <img src={SearchIcon} alt="" />
                        <FormControl
                            aria-label="Amount (to the nearest dollar)"
                            placeholder="Search"
                            className="border-start-0 border-bottom-0 border-top-0"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputWrap>
                </Col>
                <div className="d-flex align-items-center justify-content-center justify-content-sm-end my-3">
                    <ButtonContainer>
                        <PdfDownloader
                            fileName={'TRADE ADVERT RECORD'}
                            {...{
                                columns: headersPdf,
                                body: cleanUpTradeAdvertDataForPdf(
                                    allAdvert?.data,
                                ),
                            }}
                        />
                        <BarLine />
                        <CsvDownloader
                            headers={headersCsv}
                            data={allAdvert?.data}
                        />
                    </ButtonContainer>
                </div>
            </div>

            <ContainerComp>
                <TableCompData
                    columns={AdvertTableHeader(Items)}
                    data={filteredTradeAdvert}
                    progressPending={isFetching}
                    totalRows={totalRows}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                />
            </ContainerComp>
        </Container>
    );
};
